export default "__VITE_ASSET__a20635a8__"